import { SET_SEARCH_STATS } from '../actionTypes';

export const setSearchStats = ({ term, count }) => ({
    type: SET_SEARCH_STATS,
    payload: { term, count },
});

export const resetSearchStats = () => ({
    type: SET_SEARCH_STATS,
    payload: null,
});
